import { EUserCardActionTypes } from '../../actions/userCard';
import { TAppState } from '../../types/appState';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { TReduxActions } from '../../types/redux/actions';

export const userCardReducer = (state: TAppState, action: TReduxActions): TAppState => {
  switch (action.type) {
    case EUserCardActionTypes.Open:
      return {
        ...state,
        userCard: {
          isOpen: true,
        },
        mobileSide: EMobileLayoutActiveSide.Right,
      };

    case EUserCardActionTypes.Close:
      return {
        ...state,
        userCard: {
          isOpen: false,
        },
        mobileSide: EMobileLayoutActiveSide.Center,
      };

    default:
      return state;
  }
};
